import styled, { css } from 'styled-components'
import Flex from 'Components/Flex'
import {
  OUTLINE_COLOR,
  CLICKABLE_COLOR,
  SITE_NAVY_COLOR,
  MAIN_BTN_BG_COLOR,
  SELECTED_ITEM_BG_COLOR,
} from '@CSSVars/colors'
import {
  BREAK_POINT_LG,
} from '@CSSVars/variables'
import AppButton from 'Components/AppButton'

import GetAlertBtn from '../GetAlertBtn'


export const _SpecialFilterContainer = styled(Flex)`
  min-height: 36px;
   ${({ isArchive }) => (isArchive && `
      justify-content: space-between;
      gap: 12px;
   `)}
  @media screen and (max-width: 1280px) and (min-width: ${BREAK_POINT_LG}) {
    width: 100%;
    padding: 0;
    > div {
        flex: 1;
        > div {
          margin: 0;
        }
      }

  }
`
export const _MoreFilterAlertContainer = styled(Flex)`
  margin-left: 12px;
  @media screen and (max-width: 1280px) and (min-width: 1024px) {
    width: 100%;
    margin-top: 12px;
    margin-left: 0;
    > button {
      flex: 1;
    }

  }
`
export const noMinimizeStyle = css`
  @media screen and (max-width: 1280px) and (min-width: 1024px) {
    flex-direction: row !important;
    justify-content: flex-start;
    align-items: center;
    ${_SpecialFilterContainer}, ${_MoreFilterAlertContainer} {
      width: initial;
      margin: 0;
    }
    ${_MoreFilterAlertContainer} {
      margin-left: 12px;
    }
  }

`
export const _FilterBarContainer = styled(Flex)`
  min-height: 68px;
  padding: 16px 24px;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1000;
  border-bottom: ${({ filterButtonActive }) => (filterButtonActive ? 'none' : `1px solid ${OUTLINE_COLOR}`)};
  div:first-child {
    margin-left: 0;
  }


  > button {
    white-space: nowrap;
    display: flex;
    border: 1px solid ${OUTLINE_COLOR};
    margin-right: 6px;
    width: 144px;

    min-width: 144px;
    padding: 0 12px;
  }
  @media screen and (max-width: 1280px) and (min-width: 1024px) {
    min-height: ${({ dockIsOpen, isPrecon }) => (dockIsOpen && !isPrecon ? '116px' : '68px')};
    flex-direction: column !important;
    align-items: flex-start !important;

    ${({ isArchive }) => (isArchive && `
      ${_SpecialFilterContainer} {
        .dropdown {
          left: 0 !important;
        }
      }
    `)};
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    min-height: 0;
    display: none !important;
  }
  ${({ dockIsOpen }) => (!dockIsOpen ? noMinimizeStyle : '')};
`

export const _BasicFilter = styled.div`
  margin-left: 12px;
  > div > div {
    margin: 0;
  }
`


export const _MoreFilterBtn = styled(AppButton)`
  width: 144px;
  display: flex;
  justify-content: flex-start;
  white-space: nowrap;
  margin-right: 12px;
  position: relative;
  svg {
    position: absolute;
    right: 12px;
    margin-left: 24px;
  }

  border: 1px solid ${OUTLINE_COLOR};
  ${({ active }) => (active && `
    background: ${SELECTED_ITEM_BG_COLOR};
    color: white !important;
    span {
      color: white;
    }
    :hover {
      span {
        color: ${SELECTED_ITEM_BG_COLOR};
      }
    }
  `)}
  ${({ filterSelected }) => (filterSelected && `
    border: 1px solid ${SITE_NAVY_COLOR};
  `)}

  @media screen and (max-width: 1280px) and (min-width: ${BREAK_POINT_LG}) {
    max-width: 50%;
  }
`

export const _SaveAlertBtn = styled(GetAlertBtn)`
  position: relative;
  width: 156px;
  justify-content: center;
  background-color: ${MAIN_BTN_BG_COLOR};
  span { color: white; }
  svg {
    fill: white;
  }
`

export const _FilterCount = styled(Flex)`
  font-size: 12px;
  line-height: 18px;
  border-radius: 50%;
  bottom: 1px;
  text-align: center;
  position: relative;
`

export const _FilterCountText = styled.span`
  color: ${({ active }) => (active ? 'white' : CLICKABLE_COLOR)};
`

export const _Separator = styled.span`
  width: 12px;
  height: 100%;
  display: inline-block;
  vertical-align: middle;
  color: ${OUTLINE_COLOR};
  position: relative;
  & + span {
    padding-top: 2px;
  }
`


export const _SchoolMessage = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  min-width: 310px;
`
